export interface IScoreWeight {
  section: SectionType;
  value: number;
  disabled: boolean;
}

export type SectionType = 'Messaging' | 'Methodology' | 'Skills';

export type WeightKey =
  | 'MESSAGE_ADHERENCE'
  | 'MESSAGE_ADHERENCE_V2'
  | 'SCORE_CUSTOMIZED'
  | 'SCORE_SKILLS';

export interface CalcType {
  type: 'WEIGHTAVG';
  weights: Record<WeightKey, number>;
}

export const SECTION_TO_WEIGHT_KEY: Record<SectionType, WeightKey> = {
  Messaging: 'MESSAGE_ADHERENCE_V2',
  Methodology: 'SCORE_CUSTOMIZED',
  Skills: 'SCORE_SKILLS',
};

export const WEIGHT_KEY_TO_SECTION: Record<WeightKey, SectionType> = {
  MESSAGE_ADHERENCE: 'Messaging',
  MESSAGE_ADHERENCE_V2: 'Messaging',
  SCORE_CUSTOMIZED: 'Methodology',
  SCORE_SKILLS: 'Skills',
};

export const SECTION_ORDER: SectionType[] = ['Methodology', 'Messaging', 'Skills'];
export const SECTION_ORDER_DEFAULT: SectionType[] = ['Messaging', 'Methodology', 'Skills'];
